<template>
  <el-dialog class="dialog-simple" :visible.sync="visible" title="新建计划" width="980px" :close-on-click-modal="false" :close-on-press-escape="false">
    <div class="detail-content">
      <el-tabs v-model="activeName" @tab-click="handleTabChange" >
        <el-tab-pane label="按合同服务项" name="base" lazy>
          <el-form :model="dataForm" :rules="dataRule" :size="size" ref="dataForm" label-position='right' label-width="120px" v-loading="dialogLoading">
            <el-row>
              <el-col :span="12">
                <el-form-item prop="contractId" label="合同">
                  <el-select v-model="dataForm.contractId" @change="handleContractChange" style="width: 100%;" placeholder="" clearable>
                    <el-option v-for="item in contractList" :value="item.id" :label="item.name" :key="item.id"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item prop="serviceItemId" label="服务项">
                  <el-select v-model="dataForm.serviceItemId" @change="handleServiceChange" style="width: 100%;" placeholder="请先选择合同" clearable>
                    <el-option v-for="item in servicesList" :value="item.id" :label="item.typeName" :key="item.type"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-col :span="24">
                  <el-form-item>
                    <p class="title">合同信息</p>
                  </el-form-item>
                  <el-col :span="24">
                    <el-form-item label="客户">
                      {{contract.clientCompanyName}}
                    </el-form-item>
                  </el-col>
                  <el-col :span="24">
                    <el-form-item label="合同开始时间">
                      {{contract.startTime ? $moment(contract.startTime).format('YYYY/MM/DD') : ''}}
                    </el-form-item>
                  </el-col>
                  <el-col :span="24">
                    <el-form-item label="合同结束时间">
                      {{contract.endTime ? $moment(contract.endTime).format('YYYY/MM/DD') : ''}}
                    </el-form-item>
                  </el-col>
                </el-col>
              </el-col>
              <el-col :span="12">
                <el-col :span="24">
                  <el-form-item>
                    <p class="title">服务项信息</p>
                  </el-form-item>
                  <el-col :span="24" v-if="Object.hasOwnProperty.call(services, 'cycle')">
                    <el-form-item label="周期">
                      {{cycleList[services.cycle]}}
                    </el-form-item>
                  </el-col>
                  <el-col :span="24"  v-if="Object.hasOwnProperty.call(services, 'times')">
                    <el-form-item label="每周期内次数">
                      {{services.times}}
                    </el-form-item>
                  </el-col>
                  <el-col :span="24"  v-if="Object.hasOwnProperty.call(services, 'measures')">
                    <el-form-item label="关联设备">
                      <div class='measures'>
                        <span class="item" v-for="item in measure" :key="item.id"> {{item.name}},&ensp; </span>
                      </div>
                    </el-form-item>
                  </el-col>
                </el-col>
              </el-col>
            </el-row>
          </el-form>
        </el-tab-pane>
        <el-tab-pane label="自定义" name="custom" >
          <el-form :model="customForm" :rules="customRule" :size="size" ref="custom" label-position='right' label-width="120px" v-loading="dialogLoading">
            <el-col :span="12">
              <el-form-item prop="contractId" label="合同">
                <el-select v-model="customForm.contractId" @change="handleContractChange" style="width: 100%;" placeholder="" clearable>
                  <el-option v-for="item in contractList" :value="item.id" :label="item.name" :key="item.id"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item prop="name" label="计划名称">
                <el-input v-model.trim="customForm.name" placeholder="" clearable></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-col :span="24">
                <el-form-item>
                  <p class="title">合同信息</p>
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item label="客户">
                  {{contract.clientCompanyName}}
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item label="合同开始时间">
                  {{contract.startTime ? $moment(contract.startTime).format('YYYY/MM/DD') : ''}}
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item label="合同结束时间">
                  {{contract.endTime ? $moment(contract.endTime).format('YYYY/MM/DD') : ''}}
                </el-form-item>
              </el-col>
            </el-col>
            <el-col :span="12">
              <el-col :span="24">
                <el-form-item prop="type" label="类别">
                  <el-select v-model="customForm.type" style="width: 100%;" placeholder="" clearable>
                    <el-option v-for="item in types" :key="item.value" :value="item.value" :label="item.label"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <!-- <el-col :span="24">
                <el-form-item prop="name" label="计划名称">
                  <el-input v-model.trim="customForm.name" placeholder="" clearable></el-input>
                </el-form-item>
              </el-col> -->
              <el-col :span="24">
                <el-form-item prop="startTime" label="计划开始日期">
                  <el-date-picker
                    :picker-options="pickerOptions"
                    style="width: 100%;"
                    v-model="customForm.startTime"
                    type="date"
                    value-format="yyyy/MM/dd"
                    placeholder="计划开始日期">
                  </el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item prop="endTime" label="计划结束日期">
                  <el-date-picker
                    :picker-options="pickerOptions"
                    style="width: 100%;"
                    v-model="customForm.endTime"
                    type="date"
                    value-format="yyyy/MM/dd"
                    placeholder="计划结束日期">
                  </el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item prop="describe" label="描述">
                  <el-input type="textarea" :rows="2" placeholder="" v-model="customForm.describe">
                  </el-input>
                </el-form-item>
              </el-col>
            </el-col>
          </el-form>
        </el-tab-pane>
      </el-tabs>
    </div>
    <div class="dialog-footer" slot="footer" style="text-align: right">
      <el-button class="submit" :size="size" type="primary" @click="submitHandle()" :loading="dialogLoading">确 定</el-button>
      <el-button class="close" :size="size" @click="visible = false">取 消</el-button>
    </div>
  </el-dialog>
</template>

<script>
import debounce from 'lodash/debounce'
export default {
  name: 'addOrUpdate',
  data () {
    return {
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 8.64e7
        }
      },
      activeName: 'base',
      size: 'small',
      dialogLoading: false,
      visible: false,
      dataForm: {
        companyId: 0,
        contractId: '',
        serviceItemId: ''
      },
      customForm: {
        companyId: 0,
        contractId: '',
        type: '',
        name: '',
        startTime: '',
        endTime: '',
        describe: ''
      },
      contractList: [],
      contract: {},
      servicesList: [],
      services: [],
      cycleList: {
        0: '无',
        1: '周',
        2: '月',
        3: '季度',
        4: '半年',
        5: '年'
      },
      types: [
        { label: "站点改造", value: 1 },
        { label: "抢修", value: 2 },
        { label: "试验", value: 3 },
        { label: "巡检", value: 4 },
        { label: "其他", value: 5 },
        { label: "带电检测", value: 6 },
        { label: "电能安装", value: 7 }
      ],
      typeList: {
        1: '站点改造',
        2: '抢修',
        3: '试验',
        4: '巡检',
        5: '其它',
        6: '带电检测',
        7: '电能安装'
      },
      measure: []
    }
  },
  computed: {
    dataRule () {
      return {
        contractId: [
          { required: true, message: '不能为空', trigger: 'blur' }
        ],
        serviceItemId: [
          { required: true, message: '不能为空', trigger: 'blur' }
        ]
      }
    },
    customRule () {
      return {
        contractId: [
          { required: true, message: '不能为空', trigger: 'blur' }
        ],
        name: [
          { required: true, message: '不能为空', trigger: 'blur' }
        ],
        type: [
          { required: true, message: '不能为空', trigger: 'blur' }
        ],
        startTime: [
          { required: true, message: '不能为空', trigger: 'blur' }
        ],
        endTime: [
          { required: true, message: '不能为空', trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    init (id) {
      this.visible = true
      this.contract = {}
      this.services = []
      this.dataForm.id = id
      // this.handleServiceChange(1)
      this.activeName = 'base'
      this.$nextTick(() => {
        this.$refs['dataForm'].resetFields()
        this.$refs['custom'].resetFields()
        Promise.all([
          this.handleGetAllContract()
        ])
      })
    },
    handleGetAllContract () {
      this.$api.electricOperations.listElectricOperationsContractForServiceProvider(0, '', '', null, 1).then((res) => {
        if (res.success) {
          this.contractList = res.data
        }
      })
    },
    handleGetInfo () {
    },
    handleTabChange () {
    },
    handleContractChange (val) {
      this.servicesList = []
      this.contract = {}
      this.contractList.forEach((item) => {
        if (item.id === val) {
          this.contract = Object.assign({}, item)
          this.servicesList = item.services.map((item) => {
            return {
              typeName: this.typeList[item.type],
              ...item
            }
          })
          // console.log(item.services)
        }
      })
      this.dataForm.serviceItemId = ''
    },
    handleServiceChange (val) {
      // getMeasuresInfo
      // let serviceObj = {}
      this.services = {}
      this.servicesList.forEach((item) => {
        if (item.id === val) {
          let params = JSON.parse(item.params)
          this.services = Object.assign({}, {...item, ...params})
          // console.log(this.services, params)
          this.handleGetMeasures(this.services.measures)
        }
      })
      // this.services = {
      //   measures: [1,2,3],
      //   cycle: 1,
      //   times: 1
      // }
      // for (const key in serviceObj) {
      //   if (Object.hasOwnProperty.call(serviceObj, key)) {
      //     this.services.push({
      //       name: key,
      //       value: serviceObj[key]
      //     })
      //   }
      // }
      console.log(this.services)
    },
    handleGetMeasures (list) {
      if (list.length > 0) {
        this.$api.measure.getMeasuresProperties(list).then((res) => {
          if (res.success) {
            this.measure = res.data
          }
        }) 
      }
    },
    submitHandle:debounce (function () {
      if (this.activeName === 'base') {
        this.$refs['dataForm'].validate((valid) => {
          if (!valid) {
            return false
          }
          this.dialogLoading = true
          this.$api.electricOperations.addElectricOperationsPlanByContractServiceItem(
            0, 
            this.dataForm.contractId, 
            this.dataForm.serviceItemId
          ).then((res) => {
            this.dialogLoading = false
            if (res.success) {
              this.visible = false
              this.$emit('handleQuery')
            }
          })
        })
      } else {
        this.$refs['custom'].validate((valid) => {
          if (!valid) {
            return false
          }
          this.dialogLoading = true
          this.$api.electricOperations.addElectricOperationsPlan(
            0, 
            this.customForm.name,
            this.customForm.contractId,
            this.customForm.type,
            this.customForm.startTime,
            this.customForm.endTime,
            this.customForm.describe
          ).then((res) => {
            this.dialogLoading = false
            if (res.success) {
              this.$message.success('操作成功')
              this.visible = false
              this.$emit('handleQuery')
            }
          })
        })
      }
    }, 1000, { 'leading': true, 'trailing': false }) 
  }
}
</script>

<style lang="scss" scoped>
.title {
  font-size: 16px;
  text-align: left;
  // border-left: 3px solid #409EFF;
  padding: 0 0 0 16px;
}

.measures {
  white-space: pre-wrap;
  overflow-wrap: break-word;
  width: 100%;
  word-break: break-all;
  text-align: left;
}
</style>
